import { Button, Checkbox, FormControlLabel, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { isValidEmail } from '../../helpers/utils';

const Admin = (props) => {
	const { details, setDetails } = props;
	return (
		<Stack spacing={2}>
			{details.admin.map((admin, index) => {
				return (
					<Stack spacing={2}>
						<Stack
							spacing={2}
							justifyContent={'space-between'}
							direction={'row'}
							alignItems={'center'}
						>
							<Typography fontWeight={'bold'}>Admin {index + 1}</Typography>
							{index !== 0 && (
								<Button
									style={{
										width: 'fit-content',
										color: '#224C84',
										textTransform: 'none',
										textDecoration: 'underline',
									}}
									onClick={() => {
										setDetails((prev) => {
											const newadmin = [...prev.admin];
											newadmin.splice(index, 1);
											return {
												...prev,
												admin: newadmin,
											};
										});
									}}
								>
									Remove Admin
								</Button>
							)}
						</Stack>
						<Stack direction={{ md: 'row', sm: 'column' }} gap={2}>
							<TextField
								label={'First Name'}
								value={admin.first_name}
								error={!admin.first_name}
								helperText={!admin.first_name && 'First Name is required'}
								onChange={(e) => {
									setDetails((prev) => {
										const newadmin = [...prev.admin];
										newadmin[index].first_name = e.target.value;
										return {
											...prev,
											admin: newadmin,
										};
									});
								}}
								style={{
									width: '300px',
								}}
								required
							/>
							<TextField
								label={'Last Name'}
								value={admin.last_name}
								error={!admin.last_name}
								helperText={!admin.last_name && 'Last Name is required'}
								onChange={(e) => {
									setDetails((prev) => {
										const newadmin = [...prev.admin];
										newadmin[index].last_name = e.target.value;
										return {
											...prev,
											admin: newadmin,
										};
									});
								}}
								style={{
									width: '300px',
								}}
								required
							/>
						</Stack>
						<Stack direction={{ md: 'row', sm: 'column' }} gap={2}>
							<TextField
								label={'Email'}
								value={admin.email}
								error={!admin.email || !isValidEmail(admin.email)}
								helperText={
									(!admin.email && 'Email is required') ||
									(!isValidEmail(admin.email) && 'Please enter a valid email')
								}
								onChange={(e) => {
									setDetails((prev) => {
										const newadmin = [...prev.admin];
										newadmin[index].email = e.target.value;
										return {
											...prev,
											admin: newadmin,
										};
									});
								}}
								style={{
									width: '300px',
								}}
								required
							/>
							<TextField
								label={'Password'}
								value={admin.password}
								error={!admin.password}
								helperText={!admin.password && 'Password is required'}
								onChange={(e) => {
									setDetails((prev) => {
										const newadmin = [...prev.admin];
										newadmin[index].password = e.target.value;
										return {
											...prev,
											admin: newadmin,
										};
									});
								}}
								style={{
									width: '300px',
								}}
								required
							/>
						</Stack>
						<FormControlLabel
							control={
								<Checkbox
									checked={admin.roles.includes('super-admin')}
									onChange={(e) => {
										setDetails((prev) => {
											const newadmin = [...prev.admin];
											if (e.target.checked) {
												newadmin[index].roles.push('super-admin');
											} else {
												newadmin[index].roles = newadmin[
													index
												].roles.filter((role) => role !== 'super-admin');
											}
											return {
												...prev,
												admin: newadmin,
											};
										});
									}}
								/>
							}
							label="Is Super Admin?"
						/>
					</Stack>
				);
			})}
			<Button
				style={{
					width: 'fit-content',
					color: '#224C84',
					textTransform: 'none',
					textDecoration: 'underline',
				}}
				onClick={() => {
					setDetails((prev) => ({
						...prev,
						admin: [
							...prev.admin,
							{
								first_name: '',
								last_name: '',
								email: '',
								password: '',
								roles: ['company-admin'],
							},
						],
					}));
				}}
			>
				Add More Admin
			</Button>
		</Stack>
	);
};

export default Admin;
